/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Interval_DailyInputs */

const en_plan_interval_daily = /** @type {(inputs: Plan_Interval_DailyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daily`)
};

const es_plan_interval_daily = /** @type {(inputs: Plan_Interval_DailyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diario`)
};

/**
* | output |
* | --- |
* | "Daily" |
*
* @param {Plan_Interval_DailyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_interval_daily = /** @type {((inputs?: Plan_Interval_DailyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Interval_DailyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_interval_daily(inputs)
	return en_plan_interval_daily(inputs)
});